import {TaxAuthorityPage} from 'modules/TaxAuthority';

export default TaxAuthorityPage;